import { render, staticRenderFns } from "./BeschutWonen.vue?vue&type=template&id=25846ea9&scoped=true&"
import script from "./BeschutWonen.vue?vue&type=script&lang=js&"
export * from "./BeschutWonen.vue?vue&type=script&lang=js&"
import style0 from "./BeschutWonen.vue?vue&type=style&index=0&id=25846ea9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25846ea9",
  null
  
)

export default component.exports